var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['section.tabs'] = (function () {
    'use strict';

    // matches Bootstrap's lg breakpoint, where the tablist shows (d-none d-lg-block)
    const desktopQuery = window.matchMedia("(min-width: 992px)");

    // Below lg the tablist is hidden and the panes sit in an accordion, so tabpanel semantics would point at
    // tabs nobody can reach; drop them there and restore them above lg (WCAG 4.1.2)
    const syncPaneRoles = (section) => {
        section.querySelectorAll(".tab-content > .accordion-item .tab-pane").forEach((pane) => {
            if (!pane.dataset.tabLabelledby) {
                pane.dataset.tabLabelledby = pane.getAttribute("aria-labelledby") || "";
            }

            if (desktopQuery.matches) {
                pane.setAttribute("role", "tabpanel");
                pane.setAttribute("tabindex", "0");
                if (pane.dataset.tabLabelledby) {
                    pane.setAttribute("aria-labelledby", pane.dataset.tabLabelledby);
                }
            } else {
                pane.removeAttribute("role");
                pane.removeAttribute("tabindex");
                pane.removeAttribute("aria-labelledby");
            }
        });
    };

    const initialize = (section) => {
        // Opening a panel in the mobile accordion activates its tab, so the same panel shows when the viewport widens
        section.addEventListener("shown.bs.collapse", function (event) {
            const pane = event.target.querySelector(":scope > .tab-pane");
            if (!pane) return;

            const tabEl = section.querySelector(`[data-bs-toggle="tab"][data-bs-target="#${pane.id}"]`);
            if (tabEl) {
                bootstrap.Tab.getOrCreateInstance(tabEl).show();
                // a new Tab instance re-adds role="tabpanel" to every pane
                syncPaneRoles(section);
            }
        });

        syncPaneRoles(section);
        desktopQuery.addEventListener("change", () => syncPaneRoles(section));
    };

    return {
        initialize
    };

})();
